import { AdvertisementType } from "@/common/types"
import Advertisement from "./Advertisement"
import { Box, Stack } from "@mui/material"
import EmptyAdvertisement from "./EmptyAdvertisement"
import useListAdvertisementImages from "@/hooks/api/advertisements/ustListAdvertisementImages"

export default function RightAdvertisements() {
  const { data: advertisementImages, isLoading: advertisementsLoading } =
    useListAdvertisementImages()

  if (advertisementsLoading) {
    return <>...loading</>
  }

  const rightSmallImage: AdvertisementType = advertisementImages.data.filter(
    (image: AdvertisementType) => image.slot_name === "right_small"
  )[0]
  const rightLargeImage: AdvertisementType = advertisementImages.data.filter(
    (image: AdvertisementType) => image.slot_name === "right_large"
  )[0]
  return (
    <Stack sx={{ maxHeight: "700px", minWidth: "218px" }}>
      {advertisementImages.data.filter(
        (image: AdvertisementType) => image.slot_name === "right_large"
      ).length ? (
        <Advertisement
          hrefLink={rightLargeImage.action_link}
          imageUrl={rightLargeImage.large_image}
          companyName={rightLargeImage.company_name}
          advertisementId={rightLargeImage.advertisement_id}
          aspectRatio="tall"
          additionalStyling={{
            maxHeight: "360px",
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px",
            maxWidth: "218px",
          }}
        />
      ) : (
        <EmptyAdvertisement
          additionalStyling={{
            maxHeight: "360px",
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px",
            maxWidth: "218px",
          }}
        />
      )}
      <Box sx={{ height: "5%" }}></Box>
      {advertisementImages.data.filter(
        (image: AdvertisementType) => image.slot_name === "right_small"
      ).length ? (
        <Advertisement
          hrefLink={rightSmallImage.action_link}
          imageUrl={rightSmallImage.small_image}
          companyName={rightSmallImage.company_name}
          advertisementId={rightSmallImage.advertisement_id}
          aspectRatio="tall"
          additionalStyling={{
            maxHeight: "280px",
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px",
            maxWidth: "218px",
          }}
        />
      ) : (
        <EmptyAdvertisement
          additionalStyling={{
            maxHeight: "280px",
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px",
            maxWidth: "218px",
          }}
        />
      )}
    </Stack>
  )
}
